/**
 * Service-worker registration for the RealWorld Outdoors PWA.
 *
 * Registers /sw.js so already-viewed adventures, routes (GPX) and photos work
 * offline. Safe to call in dev: the SW serves code network-first, so an online
 * reload always gets the latest build.
 */
export function registerSW() {
    if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
    if (window.location.protocol !== "https:" && window.location.hostname !== "localhost") return;

    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register("/sw.js")
            .then((reg) => {
                // When a new SW is ready, activate it immediately on next load.
                reg.addEventListener("updatefound", () => {
                    const sw = reg.installing;
                    if (!sw) return;
                    sw.addEventListener("statechange", () => {
                        if (sw.state === "installed" && navigator.serviceWorker.controller) {
                            sw.postMessage("SKIP_WAITING");
                        }
                    });
                });
            })
            .catch(() => {});
    });
}
